import React from 'react'

import Box from 'components_new/atoms/Box'

import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 1, mb: 1 }}>
        <Skeleton variant="rounded" height={48} width={48} />
        <Skeleton variant="text" height={24} width={128} />
      </Box>
      <Skeleton variant="text" width={128} />
    </Box>
  )
}

Loading.displayName = 'Loading'

export default Loading
